import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'applicationDraft';

const initialState = {
    data: [],
    selection: [],
    pageNumber: 0,
    pageSize: 10,
    criteria: {},
    sort: null,
    drafts: {},
    nodeIds:{},
    changeItemSelections: {},
    changeItemTabValues: {},
    changeItemSecondTabValues: {},
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = action.payload;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = action.payload;
        },
        setSort(state, action) {
            state.sort = action.payload;
        },
        setNodeIds(state, action) {
            state.nodeIds = json.toJSON(action.payload);
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setChangeItemSelections(state, action) {
            state.changeItemSelections = json.toJSON(action.payload);
        },
        setChangeItemTabValues(state, action) {
            state.changeItemTabValues = json.toJSON(action.payload);
        },
        setChangeItemSecondTabValues(state, action) {
            state.changeItemSecondTabValues = json.toJSON(action.payload);
        }
    }
})

export const { setData, setSelection, setPageNumber, setPageSize, setNodeIds, setDrafts, setChangeItemSelections, setChangeItemTabValues, setChangeItemSecondTabValues } = slice.actions;
export const { reducer } = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectSelection = state => state[name].selection;

export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectNodeIds = state => json.fromJSON(state[name].nodeIds);
export const selectNodeId = id => state => state[name].nodeIds[id];

export const selectDraft =  (key) => (state) => selectDrafts(state)[key];
export const setDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}
export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

export const setNodeId = (key, nodeId) => (dispatch, getState) => {
    const nodeIds = selectNodeIds(getState());
    nodeIds[key] = nodeId;
    dispatch(setNodeIds(nodeIds));
}

export const selectChangeItemSelections = state => json.fromJSON(state[name].changeItemSelections);
export const selectChangeItemSelection = key => state => selectChangeItemSelections(state)[key];
export const setChangeItemSelection = (key, selection) => (dispatch, getState) => {
    const changeItemSelections = selectChangeItemSelections(getState());
    changeItemSelections[key] = selection;
    dispatch(setChangeItemSelections(changeItemSelections));
}

export const selectChangeItemTabValues = state => json.fromJSON(state[name].changeItemTabValues);
export const selectChangeItemTabValue = key => state => selectChangeItemTabValues(state)[key];
export const setChangeItemTabValue = (key, tabValue) => (dispatch, getState) => {
    const changeItemTabValues = selectChangeItemTabValues(getState());
    changeItemTabValues[key] = tabValue;
    dispatch(setChangeItemTabValues(changeItemTabValues));
}

export const selectChangeItemSecondTabValues = state => json.fromJSON(state[name].changeItemSecondTabValues);
export const selectChangeItemSecondTabValue = key => state => selectChangeItemSecondTabValues(state)[key];
export const setChangeItemSecondTabValue = (key, tabValue) => (dispatch, getState) => {
    const changeItemSecondTabValues = selectChangeItemSecondTabValues(getState());
    changeItemSecondTabValues[key] = tabValue;
    dispatch(setChangeItemSecondTabValues(changeItemSecondTabValues));
}

const applicationDraftReducer = reducer;
export default applicationDraftReducer;

